import { render, staticRenderFns } from "./GsapReveal.vue?vue&type=template&id=3843a5e2&scoped=true"
import script from "./GsapReveal.vue?vue&type=script&lang=js"
export * from "./GsapReveal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3843a5e2",
  null
  
)

export default component.exports